import React, { useEffect, useState } from "react";
import {
  TextField,
  Checkbox,
  Button,
  Typography,
  FormControlLabel,
  Box,
  Stack,
} from "@mui/material";
import { Grid } from '@mui/material';
import { Link } from "react-router-dom";
import image from "../../assets/login4.png";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import PasswordVisibility from "../../components/Common/PasswordVisibility";
import logo from "../../assets/logo.png"
const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = React.useState(false);

  const validationSchema = Yup.object({
    username: Yup.string()
      .required("Username is required")
      .min(3, "Username must be at least 3 characters"),
    password: Yup.string()
      .required("Password is required")
  });
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Login Form Submitted:", values);
      try {
        const response = await axiosInstance.post('/auth/login', values);
        console.log("register response", response);
        if (response.status === 200) {
          setIsAuthenticated(true)
          localStorage.setItem('userAuthToken', response?.data?.data?.auth_token)
          localStorage.setItem('refreshToken', response?.data?.data?.refresh)
          navigate('/')
        }
      } catch (error) {
        console.error(error);
      }
    },
  });

  const [height, setHeight] = useState('100vh');

  useEffect(() => {
    const updateHeight = () => {
      const isPortrait = window.matchMedia('(orientation: portrait)').matches;
      const width = window.innerWidth;

      // Use width < 768px as "phone"
      if (width < 768) {
        setHeight(isPortrait ? '100vh' : '100%');
        if (width === 720) {
          setHeight('100vh')
        }
      } else {
        if (width === 882) {
          setHeight('100%')
        } else {

          setHeight('100vh'); // tablet and larger always 100vh
        }
      }
    };

    updateHeight(); // Run on mount

    window.addEventListener('resize', updateHeight);
    window.addEventListener('orientationchange', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('orientationchange', updateHeight);
    };
  }, []);


  return (
    <>
      <Box className="d-flex align-items-center justify-content-center  mx-auto login-main-wrapper"
        sx={{ height: `${height}`, padding: '20px 0px' }}>
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          className="login-wrapper"
        >
          <Box className="setting-icon mb-1" display={"flex"} justifyContent={"center"} >
            <img src={logo} alt="app-logo"  loading="lazy" />
          </Box>
          <Typography variant="h5" gutterBottom className="text-center">
            Sign In
          </Typography>
          <TextField
            fullWidth
            required
            id="username"
            name="username"
            label="User Name"
            type="username"
            margin="normal"
            variant="outlined"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={formik.touched.username && formik.errors.username}
          />
          <TextField
            fullWidth
            required
            id="password"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            margin="normal"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <PasswordVisibility
                  showPassword={showPassword}
                  onToggle={() => setShowPassword(!showPassword)}
                />
              ),
            }}
          />
          <Stack
            direction="row"
            spacing={2}
            className="login-checkbox-wrapper mb-3 mt-2"
          >
            {/* <FormControlLabel
              control={<Checkbox name="remember" color="primary" className="pl-0 auth-label-wrapper" />}
              label="Remember me"
            /> */}
            <Typography variant="body1" color="secondary" className="forgot-password-label auth-label-wrapper" >
              <Link to="/forgot-password" className="router-link-color text-decoration-underline"> Forgot your password?</Link>
            </Typography>
          </Stack>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={!(formik.dirty && formik.isValid) || formik.isSubmitting}
          >
            Login
          </Button>


          <Typography variant="body1" className="mt-3 text-decoration-underline text-center auth-label-wrapper">
            Not registered yet? <Link to="/register" className="router-link-color">Sign Up</Link>
          </Typography>
        </Box>
        {/* <Grid
        container
        className="d-flex align-items-center justify-content-center vh-100 mx-auto  gap-5"
      >
        <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }} className="m-4" gap={5}>
        </Grid>
        <Grid item size={{ lg: 4, md: 6, sm: 12, xs: 12 }} className="m-4">
          <Box
            component="img"
            src={image}
            alt="Register"
            className="w-100 h-auto"
          />
        </Grid>
      </Grid> */}
      </Box>
    </>
  );
};

export default Login;
